export const onboardingTypes = {
  ADD_ONBOARDING: "ADD_ONBOARDING",
  GET_ONBOARDING: "GET_ONBOARDING",
  DELETE_ONBOARDING: "DELETE_ONBOARDING",
  EDIT_ONBOARDING: "EDIT_ONBOARDING",
  SET_ONBOARDING: "SET_ONBOARDING",
  GET_ONBOARDING_BY_ID: "GET_ONBOARDING_BY_ID",
  SET_ONBOARDING_BY_ID: "SET_ONBOARDING_BY_ID",
  IS_LOADING: "IS_LOADING",
};

export const addOnboarding = (payload: any) => ({
  type: onboardingTypes.ADD_ONBOARDING,
  payload,
});

export const getOnboarding = (payload?: any) => ({
  type: onboardingTypes.GET_ONBOARDING,
  payload,
});

export const setOnboarding = (payload: any) => ({
  type: onboardingTypes.SET_ONBOARDING,
  payload,
});

export const deleteOnboarding = (payload: any) => ({
  type: onboardingTypes.DELETE_ONBOARDING,
  payload,
});

export const editOnboarding = (payload: any) => ({
  type: onboardingTypes.EDIT_ONBOARDING,
  payload,
});

export const getOnboardingById = (payload: any) => ({
  type: onboardingTypes.GET_ONBOARDING_BY_ID,
  payload,
});

export const setOnboardingById = (payload: any) => ({
  type: onboardingTypes.SET_ONBOARDING_BY_ID,
  payload,
});

export const setOnboardingLoading = (payload: boolean) => ({
  type: onboardingTypes.IS_LOADING,
  payload,
});
